var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-eye",
    transform: "translate(-1465.5 -32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_922",
    "data-name": "Rectangle 922",
    width: 16,
    height: 16,
    transform: "translate(1466 32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8_eyebrow",
    transform: "translate(1460.522 15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8553",
    "data-name": "Path 8553",
    d: "M13.5,29.5c-5.405,0-8-5.227-8-5.227s2.595-4.773,8-4.773a9.68,9.68,0,0,1,8,4.545S18.905,29.5,13.5,29.5Z",
    transform: "translate(-0.022)",
    fill: "none",
    stroke: "#325ae7",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1, -0.017, 0.017, 1, 11.478, 22.587)",
    fill: "none",
    stroke: "#325ae7",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEye);
export default __webpack_public_path__ + "static/media/new-eye.901ebd73047e9ef4672afd1adce6b592.svg";
export { ForwardRef as ReactComponent };